import script from "./AddTeamModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AddTeamModal.vue?vue&type=script&setup=true&lang=js"

import "./AddTeamModal.vue?vue&type=style&index=0&id=2b0b96a2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b0b96a2"]])

export default __exports__